'use client'

import { useAppContext } from '@app/components/AppContext'
import { DashboardLayout } from '@app/components/Dashboard'
import SalesActivityDashboard from '@app/components/Dashboard/SalesActivity/SalesActivityDashboard'
import { LightbulbLoading } from '@app/components/LightbulbLoading'

import ErrorComponent from '../../error'

export default function SalesActivity() {
  const { userContact, isDataReady, userContactSearch } = useAppContext()

  if (userContactSearch.status === 'error')
    return <ErrorComponent error={new Error('Encountered an error getting your user contact.')} reset={() => document.location.reload()} />

  if (!isDataReady) return <LightbulbLoading />

  return (
    <DashboardLayout subtitle={"Here's today's overview."}>
      <SalesActivityDashboard contactId={userContact?.id} />
    </DashboardLayout>
  )
}
